import { Pill } from '../Pill';
import React from 'react';
import { FilterListIcon, IconSize } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { Text } from '@ardoq/typography';
import { FlexBox } from '@ardoq/layout';
import { LinkButton, LinkButtonProps } from './LinkButton';
import { SettingsButton, SettingsButtonProps } from './SettingsButton';
import { DashboardPillLabels } from './labels';

export type UnlinkedDashboardFilterPillProps = {
  label: string;
  button: LinkButtonProps;
  settings: SettingsButtonProps;
  labels?: DashboardPillLabels;
};

export const UnlinkedDashboardFilterPillView = ({
  label,
  button,
  settings,
  labels,
}: UnlinkedDashboardFilterPillProps) => (
  <Pill>
    <FlexBox gap="xsmall" align="center" paddingX="small" paddingY="xsmall">
      <FilterListIcon iconSize={IconSize.SMALL} color={colors.icon} />
      <Text color={'textDefault'}>{label}</Text>
    </FlexBox>
    <LinkButton {...button} labels={button.labels ?? labels} />
    <SettingsButton {...settings} labels={settings.labels ?? labels} />
  </Pill>
);
